import React from "react";

const AppContext = React.createContext({
  toggleAuthModal: (toggled, mode) => {},
  isAuth: undefined,
  user: undefined,
  company: undefined,
  staff: undefined,
  token: undefined,
  designStyles: {
    works: [],
    spaces: [],
    styles: [],
    workExchanges: [],
    workExchangeModelTypes: [],
    workExchangeMaterialTypes: [],
    workExchangeDrawingTypes: [],
  },
  plans: [],
  lang: undefined,
  faqs: undefined,
  setLang: (lang) => {},
  getLang: (component) => {},
  setToken: (token) => {},
  setIsAdmin: (isAdmin) => {},
  viewProject: (workId) => {},
  viewProfile: (userId) => {},
  addLikes: async (workId) => {},
  removeLikes: async (workId) => {},
  viewCompany: (companyId) => {},
  isAllowed: (resource, verb) => {},
  projectViewing: undefined,
  displayImages: (images, startingIndex) => {},
  /**
   * Display alert with confirmation
   * @param {*} title
   * @param {*} desc
   * @param {*} actions
   * @param {*} onActionClick
   */
  confirm: (title, desc, actions, onActionClick) => {},
  shareLocation: (onClose, onShare) => {},
  isTrialEnded: false,
  setIsTrialEnded: () => {},
  tenderingViewNDA: (tenderingId) => {},
});

export default AppContext;
